import { CalendarValueType, CalendarMultipleValueType, ICalendarItem } from "../types";

export function getDisplayValue(
  val: CalendarValueType | CalendarMultipleValueType,
  items: ICalendarItem[] | null,
  multiple: boolean,
) {
  let displayValue: string | string[] = ""; 
  if (val !== null && items !== null) {
    if (multiple) {
      const valueIds = (val as CalendarMultipleValueType)?.map(String);
      displayValue = items.filter((x) => valueIds!.includes(String(x.id))).map((x) => x.name);
    } else {
      const valueId = String(val as CalendarValueType);
      displayValue = items.find((x) =>String(x.id) === valueId)?.name || "";
    }
  }
  return displayValue;
}
